import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { PlusOutlined } from '@ant-design/icons'
import { PageHeader, Button } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { referralConstants } from 'locale/referrals'
import useRoleAccess from '../../../../components/AccessControl/useRoleAccess'
import { UserRole } from '@lmc/ts-common'
import { ReferralList } from './components/ReferralList'
import ReferralModal from './components/ReferralModal'
import { useReferralsList } from './hooks/useReferralsList'
import { Referral } from './types'

export const ResidentReferralsScreen: React.FC = () => {
  const { t } = useTranslation(NAMESPACE.REFERRALS)
  const { id: residentId } = useParams<{ id: string }>()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [selectedReferral, setSelectedReferral] = useState<Referral | undefined>(
    undefined
  )

  const { referrals, isLoading, refetch, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useReferralsList({
      residentId: residentId || '',
      limit: 100
    })

  const hasAddAccess = useRoleAccess([
    UserRole.lmcAdmin,
    UserRole.careHomeAdmin,
    UserRole.seniorCarer
  ])

  const handleAddClick = () => {
    setSelectedReferral(undefined)
    setIsModalVisible(true)
  }

  const handleEdit = (referral: Referral) => {
    setSelectedReferral(referral)
    setIsModalVisible(true)
  }

  const handleCloseModal = () => {
    setIsModalVisible(false)
    setSelectedReferral(undefined)
  }

  const handleSuccess = () => {
    refetch()
  }

  return (
    <>
      <PageHeader title={t(referralConstants.REFERRAL_RECORDS)} sticky>
        {hasAddAccess && (
          <Button variant="primary" onClick={handleAddClick}>
            <PlusOutlined />
            {t(referralConstants.ADD_REFERRAL)}
          </Button>
        )}
      </PageHeader>

      <ReferralList
        referrals={referrals}
        isLoading={isLoading}
        onEdit={handleEdit}
        onRefetch={refetch}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />

      <ReferralModal
        isVisible={isModalVisible}
        onClose={handleCloseModal}
        onSuccess={handleSuccess}
        referral={selectedReferral}
        residentId={residentId || ''}
      />
    </>
  )
}
